import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import { Lockr } from "@/common/Lockr";
import { NotificationManager } from "@/common/notification";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { TanstackQueryConfiguration } from "./common/constants";
import { initializeSentry } from "./common/helpers/sentryHelper";
import { initServiceWorker } from "./common/helpers/serviceWorkerManager";
import {
	DebugInfoActions,
	DebugInfoKey,
	WindowReloadReason,
	useDebugStore
} from "./common/stores/persistingStores/debugStore";

initializeSentry();

let refreshTimeout: number | undefined;

window.addEventListener("online", () => {
	if (refreshTimeout) {
		return; // avoid duplicate reloads
	}
	const debugInfoActions = useDebugStore((state: DebugInfoActions) => state);
	
	debugInfoActions.pushDebugInfoItem(DebugInfoKey.WindowReloadTriggerEvents, WindowReloadReason.WindowEventOnline);

	refreshTimeout = window.setTimeout(() => {		
		window.location.reload();
	}, 1000);
});

Lockr.setPrefix("cc4t_s3_");
const rootElement = document.querySelector("#root") as Element;

if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	
	const dependencies = {
		notificationManager: new NotificationManager(),
		queryClient: new QueryClient({
			queryCache: new QueryCache({
				onError: (error: any, query: any) => {
					if (query.options.onError) {
						query.options.onError();
					}

					if (error instanceof Error) {
						console.error(`Error on QueryClient: ${error.message}`);
					}
				},
			}),
			defaultOptions: {
				queries: {
					staleTime: TanstackQueryConfiguration.StaleTime,
				},
			},
		}),
	};

	root.render(
		<React.StrictMode>
			<App dependencies={dependencies} />
		</React.StrictMode>
	);
}

initServiceWorker();
